export default __webpack_public_path__ + "static/media/Oval 2.b82a56f7.svg";